import getAdminPermission, { getUserType } from "./getAdminPermission";

export const denyAccess = (moduleName) => {
  let isValid = false;
  const permission = getAdminPermission();
  const userType = getUserType()
  console.log({ permission });
  if (userType === "ADMIN") {
    return true;
  } else if (moduleName == "Sub-Admin") {
    return false;
  } else {
    const modulePermission = permission?.find(
      (item) => item.name === moduleName
    );
    console.log("sss", modulePermission);

    if (modulePermission) {
      isValid = modulePermission.fullAccess || modulePermission.read;
    }
  }
  return isValid;
  // return true;
};

export const canPerformAction = (moduleName) => {
  const permission = getAdminPermission();
  console.log({ permission });
 const userType = getUserType();
  if (userType === "ADMIN") {
    return true;
  }

  const modulePermission = permission?.find(
    (item) => item.name === moduleName
  );

  return modulePermission?.fullAccess ?? false;
  // return true;
};
